<div class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md animate-fade-in"
    (click)="onDiscard()">

    <div class="bg-white dark:bg-slate-800 w-full max-w-2xl max-h-[90vh] rounded-[2.5rem] shadow-2xl flex flex-col relative animate-fade-in-up z-[110] overflow-hidden"
        (click)="onClickInsideModal($event)">

        <!-- Header -->
        <div
            class="px-8 py-6 border-b border-slate-100 dark:border-slate-700 flex items-center justify-between bg-white dark:bg-slate-800 sticky top-0 z-20">
            <div class="flex items-center gap-4">
                <div class="w-12 h-12 rounded-2xl bg-amber-50 flex items-center justify-center text-amber-500">
                    <span class="material-icons text-2xl">local_parking</span>
                </div>
                <div>
                    <h2 class="text-xl font-black text-slate-800 dark:text-slate-100 tracking-tight">
                        {{ data ? 'แก้ไขโซนลานจอด' : 'สร้างโซนลานจอด' }}
                    </h2>
                    <p class="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-0.5">Parking Zone</p>
                </div>
            </div>

            <div class="flex items-center gap-3">
                <button (click)="onDiscard()"
                    class="px-6 py-2.5 rounded-xl text-slate-500 dark:text-slate-400 font-bold hover:bg-slate-100 dark:hover:bg-slate-700 transition-all text-xs">ยกเลิก</button>
                <button (click)="onSave()" [disabled]="isSaving"
                    class="px-8 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-black rounded-xl shadow-lg hover:-translate-y-0.5 transition-all flex items-center gap-2 text-xs">
                    <span *ngIf="isSaving"
                        class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                    บันทึกข้อมูล
                </button>
            </div>
        </div>

        <!-- Form Area -->
        <div class="flex-1 overflow-y-auto p-12 custom-scrollbar">
            <div class="max-w-[550px] mx-auto space-y-8">
                <!-- 
                <h3
                    class="text-xs font-black text-amber-600 uppercase tracking-widest border-l-4 border-amber-400 pl-3">
                    ข้อมูลโซน
                </h3> -->

                <div class="space-y-6">
                    <!-- ID (Read Edit) -->
                    <div *ngIf="data">
                        <label
                            class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">
                            รหัสโซน (ID)
                        </label>
                        <input type="text" [value]="data.id" disabled
                            class="w-full h-11 px-4 bg-slate-100 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl text-sm font-bold text-slate-400 cursor-not-allowed outline-none">
                    </div>

                    <!-- Name -->
                    <div>
                        <label
                            class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">
                            ชื่อโซน (Zone Name)
                        </label>
                        <input type="text" [(ngModel)]="formData.name" placeholder="เช่น โซน A, ชั้น 2A..."
                            class="w-full h-11 px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-bold focus:bg-white dark:focus:bg-slate-800 focus:ring-4 focus:ring-amber-50 dark:focus:ring-amber-900/30 transition-all outline-none text-slate-800 dark:text-slate-100">
                    </div>

                    <!-- Floor Dropdown -->
                    <div>
                        <label
                            class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">
                            ชั้น (Floor)
                        </label>
                        <div class="relative">
                            <div class="relative flex items-center">
                                <input type="text" [(ngModel)]="searchFloorText"
                                    placeholder="เลือกหรือพิมพ์ค้นหาชั้น..." (focus)="onInputFocus('floor')"
                                    (click)="onInputFocus('floor'); $event.stopPropagation()"
                                    class="w-full h-11 px-4 pr-10 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-bold text-slate-700 dark:text-slate-200 focus:bg-white dark:focus:bg-slate-800 focus:ring-4 focus:ring-amber-50 dark:focus:ring-amber-900/30 outline-none transition-all placeholder:font-normal placeholder:text-slate-400">
                                <span
                                    class="material-icons text-slate-400 text-sm absolute right-4 transition-transform pointer-events-none cursor-pointer"
                                    [class.rotate-180]="openDropdown==='floor'">expand_more</span>
                            </div>
                            <div *ngIf="openDropdown === 'floor'"
                                class="absolute top-full left-0 right-0 mt-2 z-30 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 animate-fade-in-up max-h-48 overflow-y-auto">
                                <div *ngIf="filteredFloorOptions.length === 0"
                                    class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบข้อมูลที่ค้นหา
                                </div>
                                <div *ngFor="let f of filteredFloorOptions" (click)="selectFloor(f)"
                                    class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 dark:hover:text-amber-500 cursor-pointer transition-all text-slate-700 dark:text-slate-300">
                                    {{ f }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Parking Type Dropdown -->
                    <div>
                        <label
                            class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">
                            ประเภทการจอดรถ (Parking Type)
                        </label>
                        <div class="relative">
                            <div class="relative flex items-center">
                                <input type="text" [(ngModel)]="searchParkingTypeText"
                                    placeholder="เลือกหรือพิมพ์ค้นหาประเภทรถ..." (focus)="onInputFocus('parkingType')"
                                    (click)="onInputFocus('parkingType'); $event.stopPropagation()"
                                    class="w-full h-11 px-4 pr-10 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-bold text-slate-700 dark:text-slate-200 focus:bg-white dark:focus:bg-slate-800 focus:ring-4 focus:ring-amber-50 dark:focus:ring-amber-900/30 outline-none transition-all placeholder:font-normal placeholder:text-slate-400">
                                <span
                                    class="material-icons text-slate-400 text-sm absolute right-4 transition-transform pointer-events-none cursor-pointer"
                                    [class.rotate-180]="openDropdown==='parkingType'">expand_more</span>
                            </div>
                            <div *ngIf="openDropdown === 'parkingType'"
                                class="absolute top-full left-0 right-0 mt-2 z-30 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 animate-fade-in-up max-h-48 overflow-y-auto">
                                <div *ngIf="filteredParkingTypeOptions.length === 0"
                                    class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบข้อมูลที่ค้นหา
                                </div>
                                <div *ngFor="let pt of filteredParkingTypeOptions" (click)="selectParkingType(pt)"
                                    class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 dark:hover:text-amber-500 cursor-pointer transition-all text-slate-700 dark:text-slate-300">
                                    {{ pt }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Lot Number -->
                    <div>
                        <label
                            class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">
                            จำนวนที่จอด (Lot)
                        </label>
                        <input type="number" min="0" [(ngModel)]="formData.lot"
                            class="w-full h-11 px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-bold focus:bg-white dark:focus:bg-slate-800 focus:ring-4 focus:ring-amber-50 dark:focus:ring-amber-900/30 transition-all outline-none text-slate-800 dark:text-slate-100">
                    </div>

                    <!-- Switch Online -->
                    <div class="pt-4">
                        <div (click)="toggleOnline()"
                            class="h-11 px-4 bg-slate-50 dark:bg-slate-900 hover:bg-white dark:hover:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-xl flex items-center gap-4 cursor-pointer select-none transition-all shadow-sm">
                            <div class="w-6 h-6 rounded-lg flex items-center justify-center transition-all border"
                                [ngClass]="formData.isOnline ? 'bg-amber-500 border-amber-500 text-white shadow-[0_2px_8px_rgba(245,158,11,0.4)]' : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-600 text-transparent'">
                                <span class="material-icons text-sm font-black">check</span>
                            </div>
                            <span class="text-xs font-black uppercase tracking-widest mt-0.5"
                                [ngClass]="formData.isOnline ? 'text-amber-600' : 'text-slate-400'">
                                เปิดใช้งาน (Online)
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>